export enum QueryParam {
    Tab = 'tab',
}
